import {combineReducers} from '@reduxjs/toolkit'
import supervisorReducer from './supervisor'
import companyReducer from './company'
import corporateReducer from './corporate'
import chatReducer from './notification'
import profileReducer from './profileimg'
import cleanerchatReducer from './cleanerChat'
import cleanerNotificationReducer from './cleanerNotification'
import individualNotificationReducer from './individualNotification'
import IndividualReducer from './individual'
import CleanerReducer from './cleaner'
import companychatReducer from './companychat'
import appSettingsReducer from './appSettings'
import provinceSlice from '../slice/master/provinceSlice'
const appReducer = combineReducers({
  supervisor:supervisorReducer,
  company:companyReducer,
  corporate:corporateReducer,
  chat:chatReducer,
  profileimg:profileReducer,
  cleanerchat:cleanerchatReducer,
  cleanerNotification:cleanerNotificationReducer,
  individual:IndividualReducer,
  individualNotification:individualNotificationReducer,
  cleaner:CleanerReducer,
  companychat:companychatReducer,
  province:provinceSlice,
  appSettings:appSettingsReducer
})

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};


export type RootState = ReturnType<typeof appReducer>;
export default rootReducer
